const orderStatusSelectArr =  [
  {label: 'Unpaid', value: 0},
  {label: 'Paid', value: 1},
  {label: 'Cancelled', value: 2},
  {label: 'Shipped', value: 3},
  {label: 'Partial Shipped', value: 4},
  {label: 'Received', value: 5},
  {label: 'Refund under review', value: 6},
  {label: 'Refunded', value: 7},
  {label: 'Declined on Refund', value: 8},
  {label: 'On Hold', value: 31},
  {label: 'Progressing', value: 10},
  {label: 'Partial refund', value: 9},
  {label: 'Failed', value: 11},
  {label: 'Returning', value: 13},
  {label: 'Return completed', value: 23},
  {label: 'Complete partially', value: 24},
  {label: 'Closed', value: 99},
  {label: 'Packaging', value: 40},
  {label: 'Partial Delivered', value: 52},
  {label: 'Delivered', value: 53},
  {label: 'Partial Received', value: 54}
]

const statusMap = new Map([[0, 'Unpaid'], [1, 'Paid'], [2, 'Cancelled'],
  [3, 'Shipped'], [4, 'Partial Shipped'], [5, 'Received'],
  [6, 'Refund under review'], [7, 'Refunded'], [8, 'Declined on Refund'],
  [9, 'Partial refund'], [10, 'Progressing'], [11, 'Failed'],
  [13, 'Returning'], [16, 'Refunding'], [23, 'Return completed'],
  [24, 'Complete partially'], [31, 'On Hold'], [40, 'Packaging'], [42, 'Canceled'],
  [52, 'Partial Delivered'], [53, 'Delivered'], [54, 'Partial Received'], [99, 'Closed']])

const serviceStatusMap = new Map(
  [[1, 'In Review'], [2, 'Refunding'],
    [3, 'To Arbitrate'], [4, 'Complete'],
    [5, 'Close'], [6, 'Submit'],
    [7, 'To be Returned'], [60, 'Merchant Refused'], [61, 'Operate Refused'],
    [30, 'Start To Arbitrate'], [31, 'Platform To Arbitrate'],
    [32, 'Brand To Arbitrate'], [33, 'To Arbitrate Result']])

/**
 * sku状态
 *  缺货(0,"Out of stock"),
 *  有货(1,"Active"),
 *  下架(2,"Inactive"),
 */
export const skuStatusArr = [
  {
    value: '1',
    label: 'Active'
  }, {
    value: '2',
    label: 'Inactive'
  }, {
    value: '0',
    label: 'Out of stock'
  }]
export const variantArr=[
  {
    value: 'Color',
    label: 'Color'
  },
  {
    value: 'Size',
    label: 'Size'
  },
  {
    value: 'Material',
    label: 'Material'
  },
  {
    value: 'Style',
    label: 'Style'
  },
  {
    value: 'Version',
    label: 'Version'
  }
]

export function orderStatusArr(){
  return orderStatusSelectArr
}
/**
 * 订单状态切换
 * @param status
 * @returns {string}
 */
export function orderStatusDis(status){
  return statusMap.get(status)
}

/**
 * 售后单状态切换
 * @param status
 * @returns {string}
 */
export function serviceOrderStatusDis(status){
  return serviceStatusMap.get(status)
}





// WEBPACK FOOTER //
// ./src/utils/status.js